module.exports = __webpack_public_path__ + "static/media/floor-bokeh-1.a0860043.png";